import { html, css } from 'lit';
import { customElement, query } from 'lit/decorators.js';
import { TeComponent } from './common/te-component';

/**
 * Progress Component
 *
 * @slot - Default slot for progress steps
 */
@customElement('te-progress')
export class TeProgress extends TeComponent {
  static styles = [
    ...TeComponent.styles,
    css`
      .container {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      ::slotted(*) {
        min-width: 104px;
        max-width: 176px;
        position: relative;
        flex: 1;
      }
    `,
  ];

  @query('#te-progress-steps') _slotContent?: HTMLSlotElement;

  getChildNodes() {
    if (!this._slotContent) return [];
    const nodes = this._slotContent.assignedNodes({ flatten: true });
    return nodes.filter((node) => node.nodeType === 1);
  }

  render() {
    return html`
      <div class="container">
        <slot id="te-progress-steps"></slot>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'te-progress': TeProgress;
  }
}
